module.exports = __webpack_public_path__ + "img/blue-circle.ec9944cb.svg";